import { getMessageFactory } from "../getCaxaWebSocket.js";
const getOpenFileInfo = getMessageFactory({
  code: "GET_OPEN_FILE_INFO"
});
export { getOpenFileInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/getOpenFileInfo.js